import React, { useEffect } from 'react'
import {
    Grid,
    Button,
    Typography,
    Paper,
} from "@material-ui/core";
import { EditFilled, EditOutlined } from '@ant-design/icons';
import DynamicTable from './DynamicTable';
import { ActionDropdown, HardwareModalTableHeader, HardwareTableHeader, HardwareTableRows, contractormap } from './constants';
import { DatePicker, Form, Input, message, Modal, notification, Select } from 'antd';
import { useState } from 'react';
import moment from 'moment-timezone';
import services from '../../Services';
import { CancelOutlined } from '@material-ui/icons';
import EmployeeModal from '../Modals/EmployeeModal';
import { EmployeeHardware } from '../../Services/hr';
import dayjs from 'dayjs';
import { ContractorTo, updateHardwareRow } from '../../Services/employee';
const {
    employee,
    hr
} = services;

const HardwareTable = ({ data, typeListing, userListing, editFlag, onFilter }) => {

    const [updateHardwareAss, setUpdateHardwareAss] = useState({})
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [SelectedRow, setSelectedRow] = useState(null);
    const [hardwareManufactures, sethardwareManufactures] = useState(null);

    const [triggerAssign, settriggerAssign] = useState(false)
    const [form] = Form.useForm()
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedId, setSelectedId] = useState()
    const [DataEmployee, setDataEmployee] = useState();
    const [Loading, setLoading] = useState();
    const [ContractorListData, setContractorListData] = useState([]);

    const showEmployeeModal = async (employee, id) => {
        setSelectedEmployee(employee);
        await fetchData(id); // Fetch data for the selected employee
        setSelectedId(id);
        setIsModalVisible(true);
    };


    const handleOkEmployee = () => {
        setIsModalVisible(false);
        setSelectedEmployee(null);
    };

    const handleCancelEmployee = () => {
        setIsModalVisible(false);
        setSelectedEmployee(null);
    };

    const showModal = async (data) => {
        setSelectedRow(data);

        // Check and set the appropriate dropdown based on the action
        if (data?.Action === "EmpAsssigned") {
            setSelectedId("EmpAsssigned");
            settriggerAssign(true); // Trigger to show the "Assigned to Employee" field
            form.setFieldsValue({
                assignedTo: data?.AssignToEmployee || null, // Pre-fill employee field
            });
        } else if (data?.Action === "ContractorAssigned") {
            setSelectedId("ContractorAssigned");
            settriggerAssign(true); // Trigger to show the "Assigned to Contractor" field
            await getContractorData(); // Fetch contractor data
            form.setFieldsValue({
                contractorAssignedTo: data?.AssignToContractor || null, // Pre-fill contractor field
            });
        } else {
            settriggerAssign(false); // Hide the fields if not applicable
        }

        // Set common form fields
        form.setFieldsValue({
            att1: data?.Attribute1MacAddress,
            att2: data?.Attribute2,
            status: data?.Action,
        });

        setIsModalOpen(true); // Open the modal
    };


    const [isDataReady, setIsDataReady] = useState(false);

    const fetchData = async (selectedId) => {
        setLoading(true);
        try {
            const fetchedData = await EmployeeHardware(selectedId);
            setDataEmployee(fetchedData); // Directly set the fetched data
        } catch (error) {
            console.error('Error fetching data:', error);
            setDataEmployee([]); // Optionally set to an empty array on error
        } finally {
            setLoading(false);
        }
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setUpdateHardwareAss({})
        setIsModalOpen(false);
        settriggerAssign(false)
    };
    const handleEditFields = (index, value, type) => {
        if (type == 'edit') setUpdateHardwareAss(prev => {
            return {
                ...prev, [index]: {
                    ...updateHardwareAss[index], edit: value
                }
            }
        })
        else setUpdateHardwareAss(prev => {
            return {
                ...prev, [index]: {
                    ...updateHardwareAss[index], [type]: value
                }
            }
        })

    }
    const formatDate = (date) => date ? moment.utc(date)?.format("MM-DD-YYYY") : "N/A";



    const table = {

        header: HardwareTableHeader,
        rows: data?.map((col, index) => [
            col?.HardwareTypeList?.name,
            col?.HardwareManufacturer?.name,
            col?.ModelNbr,
            col?.HwSerialNbr,
            col?.PurchaseDate ? formatDate(col?.PurchaseDate) : "N/A",
            col?.Attribute1MacAddress,
            col?.Attribute2,
            col?.RetiredDate ? formatDate(col?.RetiredDate) : "N/A",
            col?.Action,
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    // Prevent default anchor behavior
                    showEmployeeModal(col.Employee || col.ContractorMaster || null, col.id); // Pass Employee or null if not present
                }}
                className="hardware_table_employee_link"
            >

                {col?.Employee
                    ? `${col?.Employee?.firstName} ${col?.Employee?.lastName}`
                    : col?.ContractorMaster
                        ? contractormap(col?.ContractorMaster)
                        : "N/A"}

            </a>,


            <button onClick={() => showModal(col)} className="hardware_table_edit_button"><EditFilled /></button>
        ])

    }
    const Modaltable = {
        header: HardwareModalTableHeader,
        rows: [SelectedRow].map((col, index) => [
            col?.HardwareTypeList?.name,
            !updateHardwareAss[index]?.edit ? col?.HardwareManufacturer?.name :
                <Select
                    showSearch
                    defaultValue={col?.HardwareManufacturer?.name}
                    onChange={(e) => { handleEditFields(index, e, 'ManufacturerId') }}
                    optionFilterProp="label"
                    style={{
                        width: 200,
                        borderRadius: "10px"
                    }}
                    options={hardwareManufactures}
                />
            ,
            !updateHardwareAss[index]?.edit ? col?.ModelNbr : <Input
                defaultValue={col?.ModelNbr}
                placeholder='Model Number'
                onChange={(e) => { handleEditFields(index, e?.target?.value, 'ModelNbr') }}
                style={{
                    fontSize: "10px",
                    width: 150,
                }}
            />,
            !updateHardwareAss[index]?.edit ? col?.HwSerialNbr : <Input
                defaultValue={col?.HwSerialNbr}
                placeholder='Serial Number'
                onChange={(e) => { handleEditFields(index, e?.target?.value, 'HwSerialNbr') }}
                style={{
                    fontSize: "10px",
                    width: 150,
                }}
            />,
            !updateHardwareAss[index]?.edit ? moment.utc(col?.PurchaseDate).format("MM-DD-YYYY") :
                <DatePicker
                    defaultValue={moment.utc(col?.PurchaseDate)}
                    onChange={(e) => { handleEditFields(index, moment(e).format("YYYY-MM-DD"), 'PurchaseDate') }}
                    style={{ width: 150, fontSize: "10px", height: "25px" }} />,
            !updateHardwareAss[index]?.edit ? <Button
                onClick={() => { handleEditFields(index, true, 'edit') }}
                style={{
                    border: "1px solid lightgray",
                    backgroundColor: "#f5f5f5",
                    color: "#333",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "11px",
                    textTransform: "capitalize"
                }}
            >
                <EditOutlined />
            </Button> : <div style={{ display: "flex", gap: "10px" }}>
                <button
                    onClick={() => { handleSubmit(index, col) }}
                    style={{
                        border: "none", cursor: "pointer",
                        backgroundColor: "#2963AD",
                        color: "white", padding: "5px 10px",
                        textAlign: "center",
                        fontSize: "11px", borderRadius: "6px"
                    }}>
                    Submit
                </button>
                <button
                    onClick={() => { handleEditFields(index, false, 'edit') }}
                    style={{
                        border: "none", cursor: "pointer",
                        backgroundColor: "#B22222", // Maroon background color
                        color: "#fff", // White text color
                        padding: "5px 10px",
                        textAlign: "center",
                        fontSize: "11px", borderRadius: "6px"
                    }}  >
                    Cancel
                </button>
            </div>
        ])
    }


    const fetchHardwareManufactures = async () => {
        let response = await hr?.getHardwareName()
        sethardwareManufactures(response?.data?.rows?.map(manufacture => {
            return {
                value: manufacture?.id,
                label: manufacture?.title
            }
        }))
    }

    // const onFinish = async (values) => {
    //     editFlag(true)
    //     let body = {
    //         EmployeeID: values?.assignedTo,

    //         Action: values?.status,
    //         Attribute2: values?.att2,
    //         Attribute1MacAddress: values?.att1
    //     }

    //     let response = await employee.on_edit_hardware(SelectedRow?.id, body)
    //     editFlag(false)
    //     form.resetFields()
    //     handleCancel()
    //     message.success("Hardware Updated")
    // }
    const onFinish = async (values) => {
        editFlag(true);

        // Dynamically construct the payload
        let body = {
            EmployeeID: values?.assignedTo,
            Action: values?.status,
            Attribute2: values?.att2,
            Attribute1MacAddress: values?.att1,
        };

        // Only include ContractorId if it's not null
        if (values?.contractorAssignedTo) {
            body.ContractorId = values?.contractorAssignedTo;
        }

        try {
            const response = await employee.on_edit_hardware(SelectedRow?.id, body);

            if (response?.success) {
                message.success("Hardware Updated");
                form.resetFields()

            } else {
                // message.error("Failed to update hardware");
            }

            form.resetFields();
            handleCancel();
        } catch (error) {
            console.error("Error updating hardware:", error);
            message.error("An error occurred during submission");
        } finally {
            editFlag(false);
        }
    };


    const handleSubmit = async (index, col) => {
        // const result 
        editFlag(true)
        delete updateHardwareAss[index].edit
        const result = await updateHardwareRow(col?.id, updateHardwareAss[index])
        if (result?.message == 'success') {
            message?.success('Successfully Updated!')
            handleEditFields(index, false, 'edit')
            handleCancel()
        }
        editFlag(false)

    }

    const getContractorData = async () => {
        try {
            const result = await ContractorTo();
            if (result?.httpStatus === 200) {
                const list = result?.data?.map((item) => ({
                    label: `${contractormap(item)}`,
                    value: item?.id,
                }));
                setContractorListData(list);

            } else {
                message.error("Failed to fetch contractor data");
            }
        } catch (error) {
            console.error("Error fetching contractor data:", error);
            message.error("Error fetching contractor data");
        }
    };

    const onStatusChange = async (value) => {
        if (value === "EmpAsssigned") {
            settriggerAssign(true);
            setSelectedId("EmpAsssigned");
        } else if (value === "ContractorAssigned") {
            settriggerAssign(true);
            setSelectedId("ContractorAssigned");
            await getContractorData(); // Fetch contractor data for the dropdown
        } else {
            settriggerAssign(false); // Hide fields for other statuses
            setSelectedId(null);
        }
    };

    useEffect(() => {
        onStatusChange()
        fetchHardwareManufactures()
    }, [])
    return (
        <Grid xs={12} className="LiqTables ">
            <Grid xs={12} className="mt28 mb14">
                <DynamicTable tableData={table} onFilter={onFilter} />
                <Modal title="Edit Hardware Assignment" width={"60%"} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={false}>
                    <DynamicTable tableData={Modaltable} Pagination={false} />
                    <Grid xs={12}>
                        <Form onFinish={onFinish} onFinishFailed={(err) => { }} className="hardware_form" form={form}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "5px", paddingTop: "20px" }}>
                                <div className='formItem_grid'>
                                    <span>Attribute 1</span>
                                    <Form.Item name={"att1"} rules={[{ required: false, message: "" }]}>
                                        <Input
                                            style={{
                                                width: 250,
                                                borderRadius: "10px"

                                            }}
                                        />
                                    </Form.Item>
                                </div>
                                <div className='formItem_grid'>
                                    <span>Attribute 2</span>
                                    <Form.Item name={"att2"} rules={[{ required: false, message: "" }]}>
                                        <Input
                                            style={{
                                                width: 250,
                                                borderRadius: "10px"

                                            }}
                                        />
                                    </Form.Item>
                                </div>

                                <div className='formItem_grid'>
                                    <span>Status</span>
                                    <Form.Item name={"status"} rules={[{ required: true, message: "" }]}>
                                        <Select
                                            showSearch
                                            optionFilterProp='label'
                                            onChange={(value) => onStatusChange(value)}
                                            style={{
                                                width: 250,
                                                borderRadius: "10px"
                                            }}
                                            options={ActionDropdown}
                                        />
                                    </Form.Item>
                                </div>


                                {triggerAssign && (
                                    <>
                                        {selectedId === "EmpAsssigned" && (
                                            <div className="formItem_grid">
                                                <span>Employee Assigned To</span>
                                                <Form.Item
                                                    name={"assignedTo"}
                                                    rules={[{ required: true, message: "Please select an employee" }]}
                                                >
                                                    <Select
                                                        showSearch
                                                        optionFilterProp="label"
                                                        style={{ width: 250, borderRadius: "10px" }}
                                                        options={userListing}
                                                        value={form.getFieldValue("assignedTo")} // Pre-select employee
                                                    // Optionally disable field to prevent manual selection
                                                    />
                                                </Form.Item>
                                            </div>
                                        )}

                                        {selectedId === "ContractorAssigned" && (
                                            <div className="formItem_grid">
                                                <span>Contractor Assigned To</span>
                                                <Form.Item
                                                    name={"contractorAssignedTo"}
                                                    rules={[{ required: true, message: "Please select a contractor" }]}
                                                >
                                                    <Select
                                                        showSearch
                                                        optionFilterProp="label"
                                                        style={{ width: 250, borderRadius: "10px" }}
                                                        options={ContractorListData}
                                                        value={form.getFieldValue("contractorAssignedTo")} // Pre-select contractor
                                                    // Optionally disable field to prevent manual selection
                                                    />
                                                </Form.Item>
                                            </div>
                                        )}
                                    </>
                                )}


                                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                    <Grid xs={4} style={{ display: "flex", justifyContent: "center" }} >
                                        <button style={{ border: "none", cursor: "pointer", backgroundColor: "#2963AD", color: "white", padding: "8px 10px", textAlign: "center", fontSize: "13px", borderRadius: "6px" }} htmlType="submit" >Submit & Close</button>
                                    </Grid>
                                </div>
                            </div>
                        </Form>
                    </Grid>
                </Modal>
                <EmployeeModal
                    visible={isModalVisible}
                    employee={selectedEmployee}
                    onOk={handleOkEmployee}
                    onCancel={handleCancelEmployee}
                    EmployeeData={DataEmployee}
                />
            </Grid>
        </Grid >
    )
}

export default HardwareTable